import { createContext, useContext, useEffect, useState } from "react";
import { api } from "./api";

const SettingsContext = createContext(null);

// Taxonomies we always want cached on the client
const TAXONOMY_TYPES = [
  "market",
  "property_type",
  "opportunity_category",
  "investment_category",
  "lead_source",
  "pipeline_stage",
  "tag",
  "partner_type",
  "business_info",
];

export function SettingsProvider({ children }) {
  const [taxonomies, setTaxonomies] = useState({});
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const results = await Promise.all(
        TAXONOMY_TYPES.map((t) => api.get(`/public/taxonomy/${t}`).then((r) => [t, r.data]).catch(() => [t, []]))
      );
      setTaxonomies(Object.fromEntries(results));
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const get = (type) => taxonomies[type] || [];
  const business = () => {
    const arr = get("business_info");
    return Object.fromEntries(arr.map((e) => [e.key, e.meta?.value || e.label]));
  };

  return (
    <SettingsContext.Provider value={{ taxonomies, loading, get, business, refresh: load }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
